module.exports = __webpack_public_path__ + "a96b947d3e01d617afbb1d8d3ddb9ac0.svg";